import { useState, useEffect } from "react";
import axios from "axios";
import { getWasteStatistic } from "../../../services/container";
import { mergeFluxes } from "../utils/statisticsUtils";

/**
 * Hook pour charger et gérer les données de statistiques de qualité
 */
export const useQualityStatisticsData = (
  periodHistoryStart,
  periodHistoryStop,
  keywordFilter,
  handleValidate,
  setHandleValidate,
) => {
  const [data, setData] = useState({});
  const [dataSortingError, setDataSortingError] = useState({});
  const [monthlyCaracterisation, setMonthlyCaracterisation] = useState([]);
  const [fluxesList, setFluxesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [tooManyReviews, setTooManyReviews] = useState({
    numberOfReviews: 0,
    maxNumberOfReviews: 100,
  });
  const [totalAnomalies, setTotalAnomalies] = useState({});
  const [dataVolume, setDataVolume] = useState({});
  const [selectedMaterial, setSelectedMaterial] = useState("");
  const [selectedFlux, setSelectedFlux] = useState("");
  const [selectedFluxSortingErrorPie, setSelectedFluxSortingErrorPie] =
    useState("");
  const [selectedFluxCharacterizationPie, setSelectedFluxCharacterizationPie] =
    useState("");

  const fetchData = () => {
    setIsLoading(true);
    const keywordValue =
      keywordFilter &&
      typeof keywordFilter === "object" &&
      "value" in keywordFilter
        ? keywordFilter.value
        : keywordFilter || [];

    axios
      .all([
        getWasteStatistic({
          periodStart: periodHistoryStart,
          periodStop: periodHistoryStop,
          keywordFilter: JSON.stringify(keywordValue),
        }),
      ])
      .then(
        axios.spread((responseWasteStatistics) => {
          if (responseWasteStatistics.status === 200) {
            setTotalAnomalies(
              responseWasteStatistics.data.statisticsData.totalAnomalies,
            );
            setData(responseWasteStatistics.data.statisticsData.dataResult);

            const monthlyCaracterisation =
              responseWasteStatistics.data.statisticsData
                .monthlyCaracterisation || [];

            setMonthlyCaracterisation(monthlyCaracterisation);

            if (
              Array.isArray(monthlyCaracterisation) &&
              monthlyCaracterisation.length > 0
            ) {
              const uniqueFluxes = [
                ...new Map(
                  monthlyCaracterisation.map((entry) => [
                    entry.wasteCategoryId,
                    { label: entry.label, id: entry.wasteCategoryId },
                  ]),
                ).values(),
              ];
              setFluxesList(uniqueFluxes);

              setSelectedFlux(monthlyCaracterisation[0].wasteCategoryId);
              setSelectedFluxSortingErrorPie(monthlyCaracterisation[0].label);
              setSelectedFluxCharacterizationPie(
                monthlyCaracterisation[0].label,
              );

              if (monthlyCaracterisation[0].wasteData) {
                setSelectedMaterial(
                  Object.keys(monthlyCaracterisation[0].wasteData)[0] || "",
                );
              }
            }

            const materials = JSON.parse(
              localStorage.getItem("materialsDescription"),
            );
            const mergeConfig = materials.map((v) => ({
              referenceName: v.referenceName,
              possibleNames: v.possibleNames,
            }));
            setDataSortingError(
              mergeFluxes(
                responseWasteStatistics.data.statisticsData.dataSortingError,
                mergeConfig,
              ),
            );

            setDataVolume(
              responseWasteStatistics.data.statisticsData.dataVolume,
            );
            setHandleValidate(false);
            setIsLoading(false);
          }
        }),
      )
      .catch((error) => {
        if (error.response?.status === 413) {
          setTooManyReviews({
            numberOfReviews: error.response.data.numberOfReviews,
            maxNumberOfReviews: error.response.data.maxNumberOfReviews,
          });
        }
        console.error("Erreur survenue :", error);
        setHandleValidate(false);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (handleValidate) {
      fetchData();
    }
    // eslint-disable-next-line
  }, [handleValidate]);

  return {
    data,
    dataSortingError,
    monthlyCaracterisation,
    fluxesList,
    isLoading,
    tooManyReviews,
    totalAnomalies,
    dataVolume,
    selectedMaterial,
    setSelectedMaterial,
    selectedFlux,
    setSelectedFlux,
    selectedFluxSortingErrorPie,
    setSelectedFluxSortingErrorPie,
    selectedFluxCharacterizationPie,
    setSelectedFluxCharacterizationPie,
  };
};
